import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, NgForm  } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { NoteDto, GetItauTicketDto } from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'ticketInfoModal',
    templateUrl: './ticket-info-modal.component.html'
})

export class TicketInfoModalComponent extends AppComponentBase {

    @ViewChild('ticketInfoModal') modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    id: number = undefined;
    link: string = '';
    html: string = '';
    barcode: string = '';
    description: string = '';
    msg: string = '';
    showBarcodeSequence: boolean = false;
    barcodeSequence: string = '';
    name: string = '';
    dueDate: string = '';
    netAmount: string = '';

    constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }

    close(): void {
        this.active = false;
        this.id = undefined;

        this.link = '';
        this.barcode = '';
        this.name = '';
        this.description = '';
        this.msg = undefined;
        this.modal.hide();
        this.modalSave.emit();
    }

    onShown(): void { }

    public show(id: number, name: string, description: string, dueDate: string, netAmount: string, link: string, html: string, barcode: string, message: string): void {

        this.id = id;
        this.name = name;
        this.description = description;
        this.html = html;
        this.link = link;
        this.barcode = barcode;
        this.msg = message;
        this.dueDate = dueDate;
        this.netAmount = netAmount;

        this.active = true;
        this.loadBarcode();
        this.modal.show();

    }

   printTicket(): void {

        if (this.barcode && this.link.includes('ItauPayment')) {
            this.downloadTicket(this.id)
        }
    }

   downloadTicket(orderId: number): void {
        this.saving = true;
        let input = new GetItauTicketDto();
        input.orderId = orderId;
        input.html = this.html;
        this.itauPaymentServiceProxy
            .generateTicketFile(input)
            .finally(() => { this.saving = false; })
            .subscribe((result) => {
                //window.open(AppConsts.remoteServiceBaseUrl + '/Temp/Downloads/' + result.fileName);
                this.fileDownloadService.downloadTempFile(result);
                this.close()
                this.modalSave.emit();
            });
    }

        loadBarcode(): void {

        if (this.barcode && this.barcode.length == 47) {

            var barcode = this.calculateBarcode(this.barcode);
            var sequence = "";

            if (barcode.length > 0 &&
                barcode.length % 2 === 0) {
                for (var index = 0; index < barcode.length; index = index + 2) {

                    var item = Number(barcode.substr(index, 2));
                    var charCode;

                    if (item <= 49) {
                        charCode = item + 48;
                    }
                    else {
                        charCode = item + 142;
                    }

                    sequence = sequence + String.fromCharCode(charCode);
                }

                sequence = "(" + sequence + ")";
            }

            this.barcodeSequence = sequence;
        }

        setTimeout(() => {
            this.showBarcodeSequence = true;
        }, 1000);
    }

    // Convert from 47 to 44 digits
    calculateBarcode(linha) {
        return linha.substr(0, 4) + linha.substr(32, 15) + linha.substr(4, 5) + linha.substr(10, 10) + linha.substr(21, 10);
    }

}



// WEBPACK FOOTER //
// ./src/app/financial/payment/modals/ticket-info-modal.component.ts